import React from 'react'
import PropTypes from 'prop-types'
import Typography from '@material-ui/core/Typography'
import { connect } from 'react-redux'

import {
  synchronizeAllUsers,
  synchronizeAllClients,
  synchronizeAllCastings,
  synchronizePermissions,
} from '../actions/admin'

import Section from '../components/Section'
import Button from '../components/Button'


const MagicHelpers = ({
  isLoading,
  synchronizeAllUsers: synchronizeAllUsersAction,
  synchronizeAllClients: synchronizeAllClientsAction,
  synchronizePermissions: synchronizePermissionsAction,
  synchronizeAllCastings: synchronizeAllCastingsAction,
}) => {
  const handleSynchronizePermission = () => synchronizePermissionsAction()
  const handleSynchronizeValidation = () => synchronizeAllUsersAction(true)

  return (
    <div>
      <Section title="Synchronize permissions">
        <Typography className="mt1">Script to ensure that all user will have a permission document associated to its id.</Typography>
        <Button
          fullWidth
          color="primary"
          className="mt6"
          variant="contained"
          isLoading={isLoading}
          onClick={handleSynchronizePermission}
        >
            Synchronize permission of all users
        </Button>
        <Button
          fullWidth
          color="primary"
          className="mt3"
          variant="contained"
          isLoading={isLoading}
          onClick={handleSynchronizeValidation}
        >
          Synchronize validations of all users in Algolia
      </Button>
      </Section>

      <Section title="Algolia">
        <Typography className="mt1">Script to update data in Algolia corresponding to the firestore datas.</Typography>
        <Button
          fullWidth
          color="primary"
          className="mt6"
          variant="contained"
          isLoading={isLoading}
          onClick={synchronizeAllUsersAction}
        >
          Synchronize all users with Algolia
        </Button>

        <Button
          fullWidth
          color="primary"
          className="mt3"
          variant="contained"
          isLoading={isLoading}
          onClick={synchronizeAllClientsAction}
        >
          Synchronize all clients with Algolia
        </Button>

        <Button
          fullWidth
          color="primary"
          className="mt3"
          variant="contained"
          isLoading={isLoading}
          onClick={synchronizeAllCastingsAction}
        >
          Synchronize all castings with Algolia
        </Button>
      </Section>
    </div>
  )
}


MagicHelpers.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  synchronizeAllUsers: PropTypes.func.isRequired,
  synchronzeAllClients: PropTypes.func.isRequired,
  synchronizePermissions: PropTypes.func.isRequired,
  synchronizeAllCastings: PropTypes.func.isRequired,
}


const mapStateToProps = state => ({
  isLoading: state.app.isLoading,
})


export default connect(mapStateToProps, {
  synchronizeAllUsers,
  synchronizeAllClients,
  synchronizePermissions,
  synchronizeAllCastings,
})(MagicHelpers)
